import {SweetAlertOptions} from 'sweetalert2'

export const DEFAULT_CORMFIRM_MODAL = (msg?: string): SweetAlertOptions => {
  return {
    title: msg || 'Alert!',
    showCancelButton: true,
    confirmButtonText: 'OK',
    icon: 'info',
  }
}
export const DEFAULT_SUCCESS_MODAL = (msg?: string): SweetAlertOptions => {
  return {
    title: 'Successfully!',
    text: msg || '',
    icon: 'success',
  }
}
